export interface CurationListViewParam {
  map? : CurationListViewParamMap,
}
export interface CurationListViewParamMap {
  isDisplayImage?: boolean,
}

export const useCurationListView = (
  editstate: CurationEditState = null,
  def : PartList = null
) => {

  const { getItemNoImageType } = useNoImage()
  const { isNote, isNoLang } = useCurationParts(editstate, def)

  const _editstate = editstate
  const _def = def

  const addPartMsg = computed(() => {
    if (_def.parts && _def.parts.length > 0) return null
    else return { ja: 'リストに要素を追加', en: 'Add element to the list' }
  })

  const hasExternalLink = (item: ListElement) => {
    return linkProps(item).exlink
  }

  const linkProps = (item: ListElement) => {
    if (!isNote.value && editable.value) {
      return {}
    }
    if (isNote.value || _def.openActionType === 'link') {
      if (item.internalLink) {
        return {
          to: item.internalLink,
        }
      } else if (item.link) {
        if (item.link.startsWith('/')) {
          return { to: item.link }
        }
        return {
          exlink: item.link,
        }
      } else {
        return { nolink: true }
      }
    } else return { nolink: true, tag: 'button', class: 'jps-link-button' }
  }

  const linkPropsToLink = (item: ListElement) => {
    const linkPropsResult = linkProps(item)
    return linkObjectToLink(linkPropsResult)
  }

  const baseLinkProps = (item: ListElement) => {
    let link = linkProps(item)
    if (link.exlink) {
      return { to: link.exlink }
    } else {
      return link
    }
  }

  const editable = computed(() => {
    return _editstate != null
  })

  const dataStore = useDataStore()

  const cs = computed(() => {
    if (_def.csId) return dataStore.csearch(_def.csId)
    else return null
  })

  const colList = computed(() => {
    if (cs.value && cs.value.columns) return cs.value.columns
    if (_def.columns) return _def.columns
    return []
  })

  const hasImage = (item: ListElement) => {
    return item.image && item.image.imgType
  }

  const noImgType = (i: ListElement)=> {
    if (i.type === 'item') {
      if (i.data == null) return 'curation'
      return getItemNoImageType(i.data)
    } else return i.type
  }

  return {
    isNote,
    isNoLang,
    hasExternalLink,
    linkProps,
    linkPropsToLink,
    baseLinkProps,
    editable,
    dataStore,
    cs,
    colList,
    addPartMsg,
    hasImage,
    noImgType,
  }
}
